// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"413":"aac84cc3","467":"a48c086e","896":"4ee052c1"}[chunkId] + ".chunk.css";
};